export interface UserContextRoleScopeProfileIdDTO {
    userId?: number;
    userEmail?: string;
    userContextRoleScopeId?: number;
    isInternal?: boolean;
    pIds?: number[];
}
